export default "__VITE_ASSET__e$E8FRuw__"